export async function getClientIpAddress(): Promise<string> {
  try {
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    return data.ip || 'Unknown'
  } catch (error) {
    console.error('Error fetching IP address:', error)
    return 'Unknown'
  }
} 